<template>
<div>
  <Header title="个人资料" :leftHandler="onClickLeft" />
  <div class="head-portrait">
    <img :src="getAvatar(avatarImageUri)"/>
  </div>

  <div class="center-info">
    <div class="center-info-item center-item-box" >
      <van-cell title="公司名称" :value="userInfo.clientName" />
      <van-cell title="姓名" :value="userInfo.clientUserDTO&&userInfo.clientUserDTO.userName" />
      <van-cell title="易加网账号" :value="userInfo.clientCode" />
      <van-cell title="手机号" :value="userInfo.clientUserDTO&&userInfo.clientUserDTO.userMobile" />
      <van-cell title="总计积分" :value="pointList[0]&&pointList[0].pointValue" />
      <van-cell title="人员身份" :value="userInfo.clientUserDTO&&userInfo.clientUserDTO.userRoleName" />
      <van-cell v-if="$store.state.user.userRole==='01'" title="公司地址" :value="userInfo.provinceName+' '+userInfo.cityName+' '+userInfo.countyName" />
      <van-cell v-if="$store.state.user.userRole==='01'" title="邮箱" :value="userInfo.clientUserDTO&&userInfo.clientUserDTO.userMail" />
    </div>
  </div>

  <div class="center-info">
    <div class="center-info-item center-item-box" >
      <van-cell is-link to="/center/update-general">
        <template #title>
          <span class="custom-title">修改基本信息</span>
        </template>
      </van-cell>
      <van-cell is-link to="/center/update-key" v-if="$store.state.user.userRole==='01'">
        <template #title>
          <span class="custom-title">修改关键信息</span>
        </template>
      </van-cell>
      <van-cell is-link to="/center/reset-password">
        <template #title>
          <span class="custom-title">修改密码</span>
        </template>
      </van-cell>
      <van-cell is-link to="/center/workshop-transfer" v-if="$store.state.user.userRole==='01'">
        <template #title>
          <span class="custom-title">身份转移</span>
        </template>
      </van-cell>
      <van-cell   v-if="$store.state.user.userRole!=='01'" @click="handleLogout()">
        <template #title>
          <span class="custom-title">账号注销</span>
        </template>
      </van-cell>
    </div>
  </div>

  <div style="width:100%;height:20px"></div>

</div>
</template>

<script>
import Header from '@/components/header'
import { commonUtils } from '@/utils/common'
import { userUtils } from '@/utils/auth'
import centerApi from '@/api/center'
export default {
  components: {
    Header
  },
  computed: {
  },
  data () {
    return {
      pointList: [],
      couponListLength: 0,
      userInfo: {},
      avatarImageUri: ''
    }
  },
  created () {
    this.init()
  },
  methods: {
    getAvatar (img) {
      return commonUtils.getImageUrl(img)
    },
    init () {
      this.queryPointList()
      this.getClientInfo()
    },
    queryPointList () {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      centerApi.queryPointList().then(res => {
        if (res.data.resultCode === '0') {
          this.pointList = res.data.resultData.pointList
          this.$toast.clear()
        }
      })
    },
    getClientInfo () {
      centerApi.getClientInfo().then(res => {
        if (res.data.resultCode === '0') {
          this.userInfo = res.data.resultData.clientInfo
          this.avatarImageUri = this.userInfo.avatarImageUri
        } else {
        }
      })
    },
    toUserIntegration () {
      this.$router.push({ name: 'user-integration' })
    },
    gotoWeb (name) {
      console.log(name)
      this.$router.push({ name })
    },
    onClickLeft () {
      this.$router.push({ name: 'center' })
    },
    handleLogout () {
      this.$dialog.confirm({
        title: '提示',
        message: '是否要注销当前账号？'
      })
        .then(() => {
          centerApi.clientUserAccountLogout().then(res => {
            if (res.data.resultCode === '0') {
              this.$toast('注销成功！')
              userUtils.removeUserLocal()
              this.$router.push({ name: 'login2' })
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    }
  }
}
</script>

<style scoped lang="less">
/* 头像 */
.head-portrait{
    position: relative;
    width: 100%;
    height: 120px;
    padding-top: 46px;
    img{
      width: 80px;
      height: 80px;
      border-radius: 50%;
      margin-left: calc(50% - 40px);
      margin-top: 30px;
      margin-bottom: 20px;
    }
}
.center-head-portrait .center-head-portrait-bg{
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 9;
}
.center-head-portrait .center-head-portrait-wrapper{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 3.25rem;
    height: 3.25rem;
    -webkit-transform: translate(-50%,-50%);
            transform: translate(-50%,-50%);
    z-index: 10;
}
.center-head-portrait .center-head-portrait-icon{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1.95rem;
    height: 1.95rem;
    -webkit-transform: translate(-50%,-50%);
            transform: translate(-50%,-50%);
    z-index: 10;
}

.center-info{
  margin: 30px 15px 0px 15px;
  width: calc(100% - 30px);
}
.center-info-item{
  margin-top: 15px;
  padding-top: 0.1rem;
  padding-bottom: 0.06rem;
  background-color: #fff;
  // display: flex;
  // justify-content: space-evenly;
  // height: 60px;
  // line-height: 20px;
  // align-items: center;
  // text-align: center;
  //border-bottom: 5px solid #65bac7;
  border-radius: 5px;
}

/* 卡券积分 */
.center-integration-coupon{
    padding-top: 0.1rem;
    padding-bottom: 0.06rem;
    background-color: #fff;
    display: flex;
    justify-content: space-evenly;
    height: 60px;
    line-height: 20px;
    align-items: center;
    text-align: center;
    border-bottom: 5px solid #65bac7;
}
.center-integration-coupon-item{
  flex:1;
}
.center-integration-border{
  border-right: 1px solid #f1f1f1;
}
.center-integration-coupon-title{
    font-size:14px;
    color: #117281;
}
.center-integration-coupon-num{
    color: #e41b2c;
    font-size: 0.24rem;
}
.center-item-box{
  margin-top: 10px;
  align-items: center;
  vertical-align: middle;
  img{
    position: absolute;
    top: 12px;
    width: 18px;
    margin-right: 10px;
  }
  .custom-title{
    padding-left: 0px;
  }
}

.operation_box{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top:20px;
  .operation_btn{
    padding: 10px 8px;
    word-break: keep-all;
    background-color: #fff;
    border-radius: 5px;
    margin: 5px;
    border: 1px solid var(--base-green);
    color: #117281;
  }
}
</style>
